import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Checkbox } from '../../ui/checkbox';

export const Identifiers = ({ items, onChange, disabled }) => {
  const set = (i, k, v) => onChange(items.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  return (
    <div className="space-y-2" data-testid="company-identifiers">
      {items.length === 0 && <p className="text-xs text-neutral-500">None added. Examples: EIN, NYS Sales Tax ID.</p>}
      {items.map((x, i) => (
        <div key={i} className="flex flex-wrap items-center gap-2" data-testid={`company-identifier-${i}`}>
          <Input value={x.label} onChange={(e) => set(i, 'label', e.target.value)} placeholder="Label (e.g. EIN)" className="w-40" disabled={disabled} data-testid={`company-identifier-label-${i}`} />
          <Input value={x.value} onChange={(e) => set(i, 'value', e.target.value)} placeholder="Value" className="w-48" disabled={disabled} data-testid={`company-identifier-value-${i}`} />
          <label className="flex items-center gap-2 text-xs"><Checkbox checked={!!x.show_on_documents} onCheckedChange={(v) => set(i, 'show_on_documents', !!v)} disabled={disabled} data-testid={`company-identifier-show-${i}`} />Show on customer documents</label>
          <Button size="sm" variant="ghost" disabled={disabled} onClick={() => onChange(items.filter((_, j) => j !== i))} data-testid={`company-identifier-remove-${i}`}><Trash2 className="w-4 h-4" /></Button>
        </div>
      ))}
      <Button size="sm" variant="outline" disabled={disabled || items.length >= 10} onClick={() => onChange([...items, { label: '', value: '', show_on_documents: false }])} data-testid="company-identifier-add"><Plus className="w-4 h-4 mr-1" />Add identifier</Button>
      <p className="text-xs text-neutral-500">IDs stay internal unless you tick "Show on customer documents".</p>
    </div>
  );
};
